<template>

    <div id="account">

        <div class="flex">
            <div class="flex-1 mb-4">
                <h1 class="text-2xl font-medium text-gray-900 capitalize" v-if="loaded && form.data.name">{{ form.data.name }}</h1>
                <h1 class="text-2xl font-medium text-gray-900 capitalize" v-else>Account # {{ $route.params.id }}</h1>
            </div>

            <div class="flex items-center mb-4 text-gray-400 text-sm text-right">
                <p class="hidden lg:block" v-if="loaded && form.data.name && form.data.primary_users_name ">
                    Primary User <span class="font-medium">{{ form.data.primary_users_name }}</span>
                    (<a :href="`mailto:${form.data.primary_users_email}`" target="_blank">{{ form.data.primary_users_email }}</a>)
                    <br>
                    <span class="w-full text-xs text-right">{{ formatDate(form.data.primary_users_email_verified_at) }}</span>
                </p>
                <p class="hidden lg:block" v-else>
                    No Account User (Deleted)
                </p>

                <router-link :to="{ name: 'accounts' }" custom v-slot="{ navigate }">
                    <button @click="navigate" class="btn-outline ml-4 text-sm">
                        Go back
                    </button>
                </router-link>
            </div>
        </div>
        <div v-if="loaded">

            <div class="mt-2 grid grid-cols-1 gap-5 lg:grid-cols-2">
                <AccountSettings :accountId="accountId" v-model="form" @updatedAccountTenant="updatedAccountTenant"></AccountSettings>

                <AccountTags v-model="form"></AccountTags>

                <AccountFunds v-model="form" :funds="funds.funds"></AccountFunds>

                <AccountProducts v-model="form" :product="product"></AccountProducts>

                <AccountDiscounts v-model="form" :product="product"></AccountDiscounts>
            </div>
        </div>
        <Loading message="Loading Account" v-else></Loading>
    </div>

</template>

<script>
import Loading from "../Support/Loading";
import {Account} from "../../app/Auth/Account.js";
import {Product} from "../../app/Product/Product";
import ProductSearchSelector from "../Product/ProductSearchSelector";
import ConfirmationModal from "../Support/ConfirmationModal";
import AccountProducts from "./AccountProducts";
import AccountDiscounts from "./AccountDiscounts";
import AccountTags from "./AccountTags";
import AccountCostIndex from "./AccountCostIndex";
import AccountSettings from "./AccountSettings";
import {FormattingMixin, PermissionMixin} from "../../support/mixins";
import AccountFunds from "./AccountFunds";
import {Funds} from "../../app/Funds/Funds";

export default {
    name: "ShowAccount",
    mixins: [PermissionMixin, FormattingMixin],
    data() {
        return {
            accountId: this.$route.params.id,
            form: null,
            product: null,
            funds: null,
            loaded: false,
            account_product_search: false,
            product_discount_search: false,
        }
    },
    components: {
        Loading,
        AccountFunds,
        AccountTags,
        AccountCostIndex,
        AccountDiscounts,
        AccountProducts,
        AccountSettings,
        ProductSearchSelector,
        ConfirmationModal
    },
    methods: {
        updatedAccountTenant() {
            let vm = this;

            Promise.all([
                vm.form.getAccountProducts(),
                vm.form.getAccountDiscounts(),
            ]);
        }
    },
    mounted() {
        let vm = this;

        new Promise(resolve => {
            vm.form = new Account();
            vm.product = new Product();
            vm.funds = new Funds();

            vm.form.show(vm.$route.params.id).then(response => {

                Promise.all([
                    vm.form.getCostIndexes(),
                    vm.form.getAccountProducts(),
                    vm.form.getAccountDiscounts(),
                    vm.form.getTenants(),
                    vm.funds.getFunds(vm.$route.params.id),
                    vm.product.list(null, vm.$route.params.id),
                ]).then(result => {
                    resolve(true);
                })
            }).catch(error => vm.handleError(error));

        }).then(result => {
            vm.loaded = result;
        });
    }
}
</script>


